<template>
<div>
  <el-row class="title-table" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h3 mr-r15">{{tableTitle}}</div>
      <div class="setting-addel mr-r4">
        <el-button size="mini" @click="clickAddRscButton"><i class="fas fa-plus"></i></el-button>
        <el-button size="mini" @click="clickDeleteRscButton" :disabled="checkedRows==0"><i class="fas fa-minus"></i></el-button>
      </div>
    </div>
    <div class="vertical-center-box">
      <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper :data="rscTableData" :columns="rscTableColumn" :column-default="columnDefault" row-class-name="c-dblclick" ref="rscTable" @selection-change="changeCheckedRow" @row-dblclick="dblclickRow" :pagination="false" style="width:100%;" :show-search-tool="showSearchTool"
    :show-custom-header="true">
  </el-table-wrapper>
  <w-add-rsc-popup ref="addRscPopup" :managetype-id="managetypeId" :rsctype-id="rsctypeId" :orderby-index="orderbyIndex" :managetype-key="managetypeKey" @re-load="loadData"></w-add-rsc-popup>
  <w-update-rsc-popup ref="updateRscPopup" :managetype-id="managetypeId" :rsctype-id="rsctypeId" @re-load="loadData" :update-row="updateRow"></w-update-rsc-popup>
</div>
</template>

<script>
import { cloneDeep, isNil } from 'lodash';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import RscSettingsAPI from '@/api/settings/common/rsc-settings';
import WAddRscPopup from '../popup/AddRscPopup';
import WUpdateRscPopup from '../popup/UpdateRscPopup';

export default {
  name: 'WRscTable',
  components: {
    WAddRscPopup,
    WUpdateRscPopup,
  },
  props: {
    selectedRsctypeRow: Object,
  },
  watch: {
    selectedRsctypeRow: {
      handler(row) {
        if (!isNil(row)) {
          this.tableTitle = `[${row.rsctypeName}] 자원 목록`;
          this.managetypeId = row.managetypeId;
          this.managetypeKey = row.managetypeKey;
          this.rsctypeId = row.rsctypeId;
        } else {
          this.tableTitle = '자원 목록';
        }
        this.loadData();
      },
    },
  },
  data() {
    return {
      tableTitle: '자원 목록',
      updateRow: null,
      showSearchTool: false,
      managetypeKey: null,
      managetypeId: null,
      rsctypeId: null,
      orderbyIndex: 1,
      checkedRows: [],
      rscTableData: [],
      columnDefault,
      rscTableColumn: [
        {
          type: 'selection',
        },
        {
          prop: 'rscId',
          label: '자원 ID',
          searchable: true,
        },
        {
          prop: 'rscName',
          label: '자원명',
          searchable: true,
        },
        {
          prop: 'rscUnit',
          label: '자원 단위',
          width: 100,
        },
        {
          prop: 'groupstatType',
          label: '그룹 통계 구분',
          width: 100,
        },
        {
          prop: 'rscDatatypeId',
          label: '자원 수집 결과 형태',
          width: 100,
        },
        {
          prop: 'eventMessageFormatName',
          label: '이벤트 메시지 포멧',
        },
      ],
    };
  },
  methods: {
    loadData() {
      const selectedRsctypeRow = this.selectedRsctypeRow;
      if (!isNil(selectedRsctypeRow)) {
        const managetypeId = selectedRsctypeRow.managetypeId;
        const rsctypeId = selectedRsctypeRow.rsctypeId;
        RscSettingsAPI.getRscList({
          managetypeId,
          rsctypeId,
        }).then((response) => {
          this.rscTableData = response.data.data;
        });
      } else {
        this.rscTableData = [];
      }
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    clickAddRscButton() {
      if (!isNil(this.rscTableData)) {
        if (this.rscTableData.length > 0) {
          this.orderbyIndex = this.rscTableData[this.rscTableData.length - 1].orderbyIndex + 1;
        }
      }
      this.$refs.addRscPopup.$refs.slidingPopup.visible = true;
    },
    clickDeleteRscButton() {
      const action = msgUtil.action.DELETE;
      const target = '자원';
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        const params = {
          checkedRows: JSON.stringify(this.checkedRows),
          managetypeKey: this.managetypeKey,
        };
        RscSettingsAPI.deleteRscs(params)
          .then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.checkedRows = [];
              this.loadData();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
      });
    },
    dblclickRow(row) {
      this.updateRow = cloneDeep(row);
      this.$refs.updateRscPopup.$refs.slidingPopup.visible = true;
    },
    changeCheckedRow(selection) {
      this.checkedRows = selection;
    },
  },
};
</script>

<style>
.title-table {
  //padding: 10px 0px 10px 0px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/RscSettings/components/RscTable.vue